export enum AdminModelOperationType {
  CREATE,
  UPDATE,
  UNCHANGED,
  SOFT_DELETE,
  REINSTATE,
  INVALID,
}

export namespace AdminModelOperationType {
  let elements = [
    AdminModelOperationType.CREATE,
    AdminModelOperationType.UPDATE,
    AdminModelOperationType.UNCHANGED,
    AdminModelOperationType.SOFT_DELETE,
    AdminModelOperationType.REINSTATE,
    AdminModelOperationType.INVALID,
  ];
  let alias = "com.bcdfx.model.common.api.enums.AdminModelOperationType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
